import React from 'react';

const formatDuration = (seconds) => {
  const safe = Number(seconds || 0);
  const minutes = Math.floor(safe / 60);
  const remaining = safe % 60;
  return `${minutes}:${String(remaining).padStart(2, '0')}`;
};

export default function MediaCard({ item, active, onSelect }) {
  const isVideo = item.type === 'video';

  return (
    <article className={`mp-media-card ${active ? 'is-active' : ''}`}>
      <button type="button" className="mp-media-card__thumb" onClick={() => onSelect(item)}>
        <img src={item.thumb || item.small || item.medium || item.large} alt={item.author || 'Pexels'} loading="lazy" />
        <span className="mp-media-card__overlay">Selecionar</span>
        {isVideo && (
          <span className="mp-media-card__video-badge" aria-hidden="true">▶ {formatDuration(item.duration)}</span>
        )}
      </button>

      <div className="mp-media-card__meta">
        <span>{isVideo ? 'Vídeo por' : 'Foto por'} {item.author || 'Pexels'}</span>
        <a href={item.author_url || 'https://www.pexels.com'} target="_blank" rel="noreferrer">Pexels</a>
      </div>
    </article>
  );
}
